import React from 'react';
import { Calendar, Info } from 'lucide-react';
import { Select } from '../ui/select';
import { Card } from '../ui/card';

interface BillingPeriodSelectorProps {
  month: number;
  year: number;
  onChange: (month: number, year: number) => void;
  startDate?: string; // Para comparar e mostrar warning se diferente
  className?: string;
}

export const BillingPeriodSelector: React.FC<BillingPeriodSelectorProps> = ({
  month,
  year,
  onChange,
  startDate,
  className = ''
}) => {
  const months = [
    { value: '1', label: 'Janeiro' },
    { value: '2', label: 'Fevereiro' },
    { value: '3', label: 'Março' },
    { value: '4', label: 'Abril' },
    { value: '5', label: 'Maio' },
    { value: '6', label: 'Junho' },
    { value: '7', label: 'Julho' },
    { value: '8', label: 'Agosto' },
    { value: '9', label: 'Setembro' },
    { value: '10', label: 'Outubro' },
    { value: '11', label: 'Novembro' },
    { value: '12', label: 'Dezembro' }
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 2 + i);
  const yearOptions = years.map(y => ({ value: y.toString(), label: y.toString() }));

  const handleMonthChange = (value: string) => {
    onChange(parseInt(value), year);
  };

  const handleYearChange = (value: string) => {
    onChange(month, parseInt(value));
  };

  // Safe month label getter with validation
  const getMonthLabel = (monthValue: number): string => {
    // Clamp month to valid range (1-12)
    const clampedMonth = Math.max(1, Math.min(12, monthValue));
    const monthIndex = clampedMonth - 1;

    return months[monthIndex]?.label || 'Mês inválido';
  };

  const safeMonthLabel = getMonthLabel(month);

  return (
    <div className={`space-y-3 ${className}`}>
      <div className="flex items-center gap-2 text-sm text-foreground-primary">
        <Calendar className="w-4 h-4 text-blue-400" />
        <label className="font-medium">Mês de Débito das Horas</label>
      </div>

      <div className="flex gap-3">
        <div className="flex-1">
          <Select
            value={month.toString()}
            onChange={handleMonthChange}
            options={months}
            placeholder="Selecione o mês"
          />
        </div>

        <div className="w-28">
          <Select
            value={year.toString()}
            onChange={handleYearChange}
            options={yearOptions}
            placeholder="Ano"
          />
        </div>
      </div>

      {/* Info card */}
      <Card variant="glass" className="p-3 border-blue-500/20 bg-blue-500/5">
        <div className="flex items-start gap-2">
          <Info className="w-4 h-4 mt-0.5 text-blue-400 flex-shrink-0" />
          <div className="text-xs text-foreground-secondary">
            <div className="font-medium text-foreground-primary">
              As horas das tarefas serão debitadas do banco de horas de{' '}
              <span className="text-blue-400">{safeMonthLabel}/{year}</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
